module.exports = __webpack_public_path__ + "assets/img/title-ccff09c2.png";